import { addIdToResolve, resolveIdAndRequireAll } from "./idResolving";
import { debugLog } from "../debugLog";
let busyLevel = -1;
export const checkBusyState = (type) => {
    const startBusyBlock = addIdToResolve(type);
    const releaseBusyBlock = resolveIdAndRequireAll(type);
    return (payload) => {
        const state = payload;
        if (state.busy === undefined) {
            return true;
        }
        const newBusyState = Number(state.busy);
        const transitionedToUnblocked = busyLevel >= 2 && newBusyState < 2;
        const transitionedToBlocked = busyLevel < 2 && newBusyState >= 2;
        debugLog(`Busy state: ${transitionedToUnblocked ? "transitionedToUnblocked" : ""} / ${transitionedToBlocked ? "transitionedToBlocked" : ""}`, state.busy);
        if (transitionedToBlocked) {
            startBusyBlock({ id: "hard-busy" });
        }
        else if (transitionedToUnblocked) {
            releaseBusyBlock({ id: "hard-busy" });
        }
        busyLevel = newBusyState;
        return true;
    };
};
